import './style.scss';
import {gsap} from "gsap";

export function headerBlock() {
  const header = document.querySelector('header');
  if (!header) return;
  
  const burgerMenu = header.querySelector('.burger-menu');
  const menuLinks = header.querySelector('.navbar');
  if (!burgerMenu) return;
  
  const burgerSpans = burgerMenu.querySelectorAll('span');
  gsap.set(burgerSpans, {transformOrigin: 'center'});
  
  // ✅ Define burger timeline safely
  const burgerTl = gsap.timeline({paused: true});
  burgerTl
      .to(burgerSpans, {
        y: gsap.utils.wrap([`10px`, 0, `-10px`]),
        duration: 0.25,
      })
      .set(burgerSpans, {autoAlpha: gsap.utils.wrap([1, 0, 1])})
      .to(burgerSpans, {rotation: gsap.utils.wrap([45, 0, -45])})
      .set(burgerSpans, {rotation: gsap.utils.wrap([45, 0, 135])});
  
  const overlay = header.querySelector(".overlay");
  const fullScreenMenu = header.querySelector(".full-screen-menu");
  
  // ✅ Function to close all panel menus
  function closeAllMenus(callback) {
    const openMenu = header.querySelector(".menu-panel.active");
    const openLi = header.querySelector(".panel-button.active");
    
    if (openMenu) {
      openMenu.classList.remove("active");
      openMenu.classList.add("closing");
      
      if (openLi) openLi.classList.remove("active");
      
      openMenu.addEventListener("transitionend", function handler() {
        openMenu.classList.remove("closing");
        openMenu.removeEventListener("transitionend", handler);
        if (callback) callback();
      });
    } else {
      if (callback) callback();
    }
  }
  
  // ✅ Burger menu toggle
  // ✅ Burger menu toggle (close panels when opening or closing)
  burgerMenu.addEventListener('click', function () {
    if (burgerMenu.classList.contains('burger-menu-active')) {
      // 🔹 When closing the burger, also close any open panel first
      closeAllMenus(() => {
        overlay.classList.remove('active');
        fullScreenMenu.classList.remove('active');
        header.classList.remove('hover-state');
        document.documentElement.classList.remove('modal-opened');
        
        // Then close the burger menu itself
        burgerMenu.classList.remove('burger-menu-active');
        menuLinks.classList.remove('header-links-active');
        header.classList.remove('header-active');
        burgerTl.reverse();
      });
    } else {
      // 🔹 When opening the burger, close any open panel first
      closeAllMenus(() => {
        overlay.classList.remove('active');
        fullScreenMenu.classList.remove('active');
        header.classList.remove('hover-state');
        document.documentElement.classList.remove('modal-opened');
        
        // Then open the burger menu
        burgerMenu.classList.add('burger-menu-active');
        menuLinks.classList.add('header-links-active');
        header.classList.add('header-active');
        burgerTl.play();
        document.documentElement.classList.add('modal-opened');
        
        // Animate menu items
        gsap.fromTo(
            menuLinks.querySelectorAll('.menu-item , .cta-wrappers'),
            {y: 30, autoAlpha: 0},
            {y: 0, autoAlpha: 1, stagger: 0.05, duration: 0.4, delay: 0.5}
        );
      });
    }
  });
  
  
  const headerItems = header.querySelectorAll(".panel-button");
  const headerLinks = header.querySelectorAll(".menu-item");
  
  // ✅ Handle panel button clicks
  headerItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = item.dataset.target;
      const targetMenu = document.getElementById(targetId);
      if (!targetMenu) return;
      
      const isAlreadyActive = targetMenu.classList.contains("active");
      
      if (isAlreadyActive) {
        closeAllMenus(() => {
          overlay.classList.remove("active");
          fullScreenMenu.classList.remove("active");
          header.classList.remove("hover-state");
          document.documentElement.classList.remove("modal-opened");
          
          // 🔹 Re-enable header links
          headerLinks.forEach(link => link.style.pointerEvents = "auto");
        });
      } else {
        closeAllMenus(() => {
          targetMenu.classList.add("active");
          item.classList.add("active");
          overlay.classList.add("active");
          fullScreenMenu.classList.add("active");
          
          // ✅ Mobile: add hover-state when panel opens
          if (window.matchMedia("(max-width: 991px)").matches) {
            header.classList.add("hover-state");
          }
          
          // 🔹 Disable header links when a panel is open
          headerLinks.forEach(link => link.style.pointerEvents = "none");
          
          // 🔹 Add modal-opened class to <html>
          document.documentElement.classList.add("modal-opened");
        });
      }
    });
  });
  
  // ✅ Overlay and close buttons behavior
  overlay.addEventListener("click", () => {
    closeAllMenus(() => {
      overlay.classList.remove("active");
      fullScreenMenu.classList.remove("active");
      header.classList.remove("hover-state");
      document.documentElement.classList.remove("modal-opened");
      
      // 🔹 Re-enable header links
      headerLinks.forEach(link => link.style.pointerEvents = "auto");
    });
  });
  
  header.querySelectorAll(".menu-panel .close").forEach((btn) => {
    btn.addEventListener("click", () => {
      closeAllMenus(() => {
        overlay.classList.remove("active");
        fullScreenMenu.classList.remove("active");
        header.classList.remove("hover-state");
        document.documentElement.classList.remove("modal-opened");
        
        // 🔹 Re-enable header links
        headerLinks.forEach(link => link.style.pointerEvents = "auto");
      });
    });
  });
  
  ////// ✅ Hover detection using CSS variable (desktop only)
  const menuItems = header?.querySelectorAll('.menu-item-has-children');
  
  function checkHover() {
    // Run only on desktop
    if (window.matchMedia("(min-width: 992px)").matches) {
      let isAnyHovered = false;
      
      menuItems.forEach(item => {
        const styles = getComputedStyle(item);
        const hovered = styles.getPropertyValue('--hovered').trim();
        if (hovered === '1') {
          isAnyHovered = true;
        }
      });
      
      if (isAnyHovered) {
        header.classList.add('hover-state');
      } else {
        header.classList.remove('hover-state');
      }
    }
  }
  
  // ✅ requestAnimationFrame for smooth hover tracking
  function hoverWatcher() {
    checkHover();
    requestAnimationFrame(hoverWatcher);
  }
  
  hoverWatcher();
  // Get Team Member Random — each mega menu panel gets a different person
  const panels = header.querySelectorAll('.main-left-panel .team-member-wrapper');
  const baseOffset = Math.floor(Math.random() * 1000);
  panels.forEach((panel, index) => {
    const offset = baseOffset + index;
    fetch(ajaxUrl + "?action=get_random_team&offset=" + offset + "&_t=" + Date.now())
        .then(res => res.json())
        .then(data => {
          if (!data || !data.name) return;
          
          panel.style.opacity = 1;
          panel.innerHTML = `
          <div class="profile-info">
              <p class="subheading-12 name">${data.name}</p>
              <p class="subheading-12">${data.job ?? ''}</p>
              <p class="subheading-12">${data.location ?? ''}</p>
          </div>
          ${data.image ? `
           <picture class="profile-photo">
  <img
    src="${data.image}"
    alt="${data.name}"
    loading="lazy"
    decoding="async"
  >
</picture>
          ` : ''}
        `;
        });
  });
  
  ////// end hover
  
  // ✅ Click outside to close desktop mega menus
  const megaMenus = header.querySelectorAll(".menu-item.menu-item-has-children");
  const desktopMegaWrappers = document.querySelectorAll(".mega-menu-wrapper");
  
  document.addEventListener("click", (event) => {
    const isMenuClick = event.target.closest(".menu-item.menu-item-has-children");
    const isMegaMenuClick = event.target.closest(".mega-menu-wrapper");
    
    if (!isMenuClick && !isMegaMenuClick) {
      megaMenus.forEach((menuItem) => menuItem.classList.remove("active"));
      desktopMegaWrappers.forEach((wrapper) => wrapper.classList.remove("active"));
      header.classList.remove("active");
    }
  });
  
  // ✅ Gear Search Logic
  const gearSearchForm = document.querySelector('#menu-search form.wrapper');
  if (gearSearchForm) {
    const gearSearchRadios = gearSearchForm.querySelectorAll('input[name="gear-search"]');
    gearSearchRadios.forEach(radio => {
      radio.addEventListener("change", function () {
        // Remove 'active' from all gear search labels
        gearSearchRadios.forEach(r => {
          if (r.closest('.option-wrapper')) {
            r.closest('.option-wrapper').classList.remove('active');
          }
        });
        // Add 'active' to the selected one
        if (this.checked && this.closest('.option-wrapper')) {
          this.closest('.option-wrapper').classList.add('active');
        }
      });
    });
    
    gearSearchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      
      let selectedType = "hire";
      const checkedRadio = gearSearchForm.querySelector('input[name="gear-search"]:checked');
      if (checkedRadio) selectedType = checkedRadio.value;
      
      const searchInput = gearSearchForm.querySelector('input[type="search"]');
      const term = searchInput ? searchInput.value.trim() : "";
      
      const baseSiteUrl = typeof ajaxUrl !== 'undefined' ? ajaxUrl.replace('/wp-admin/admin-ajax.php', '') : window.location.origin;
      let url = `${baseSiteUrl}/products/?product-category%5B%5D=gear-${selectedType}`;
      
      if (term) {
        url += `&q=${encodeURIComponent(term)}`;
      }
      
      window.location.href = url;
    });
  }
  
  ////// ✅ intl-tel-input MutationObserver (unchanged)
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (
              node instanceof HTMLElement &&
              node.matches('.intl-tel-input.iti-container') &&
              node.querySelector('.country-list')
          ) {
            document.body.classList.add('model-opened');
          }
        }
        
        for (const node of mutation.removedNodes) {
          if (
              node instanceof HTMLElement &&
              node.matches('.intl-tel-input.iti-container')
          ) {
            document.body.classList.remove('model-opened');
          }
        }
        
        const anyOpen = document.querySelectorAll('.intl-tel-input.iti-container .country-list').length > 0;
        if (!anyOpen) {
          document.body.classList.remove('model-opened');
        }
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
